import '../css'
import './map'

const updateForm = ({ target }) => {
  const form = target.closest('form')

  fetch(form.action, {
    method: form.method,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: new FormData(form)
  })
    .then(resp => {
      if (resp.ok) return resp.text()
    })
    .then(text => {
      const container = form.closest('.form-container')
      if (container) {
        container.innerHTML = text
        initSelect2()
      }
    })
}

const initSelect2 = () => {
  $('#site_country_ids, #site_country_division_ids, #site_activity_ids, #site_job_ids, #site_translations').select2()
}

$(initSelect2)
$(document).on('cocoon:after-remove', '#edit-site-options', updateForm)
$(document).on('change', '.autoupdate', updateForm)

addEventListener('submit', e => {
  if (e.target.matches('#edit-site-options')) {
    e.preventDefault()
    updateForm(e.target)
  }
})
